const script = require('./script')

module.exports = {
  Block: require('./block'),
  ECPair: require('./ecpair'),
  Transaction: require('./transaction'),
  TransactionBuilder: require('./transaction_builder'),

  address: require('./address'),
  bip32: require('bip32'),
  crypto: require('./crypto'),
  networks: require('./networks'),
  opcodes: require('bitcoin-ops'),
  payments: require('./payments'),
  script: script
}



//////////////////
// WEBPACK FOOTER
// ./~/bitcoinjs-lib/src/index.js
// module id = 29
// module chunks = 0